import React, { useState, useEffect, useContext } from "react";
import CustomFilters from "../../../core/custom-filters";
import { Box, TextField } from "@mui/material";
import { HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import SiAutocomplete from "../../../core/si-autocomplete";
import SiTextField from "../../../core/si-textfield";
import AppContext from "../../../utils/context";
import { USER_ROLES } from "../../../utils/constants";
import { PAGE_LIMIT } from "../../../utils";
const ClaimsFilters = ({ loadData, isSap = false }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  const [endDate, setEndDate] = useState("");
  const { userDetails = {} } = useContext(AppContext);
  let oemTimeout = null;
  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          if (key === "dateOfClaimSubmission") {
            payload["startDate"] = filters[key];
            if (endDate) {
              payload["endDate"] = endDate;
            }
          } else {
            payload[key] = filters[key];
          }
        }
      }

      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = () => {
    const filtersArr = [
      { label: "Filter by Dealer Name", value: "dealerName" },
      {
        label: "Filter by Claim Reference Number",
        value: "claimReferenceNumber",
      },
      { label: "Filter by Engine Serial Number", value: "engineSerialNumber" },

      {
        label: "Filter by Simpson Part Number",
        value: "simpsonPartNumber",
      },
      {
        label: "Filter by Date of Claim Submission",
        value: "dateOfClaimSubmission",
      },
    ];
    if (!isSap) {
      filtersArr.push({
        label: "Filter by Machine Serial Number",
        value: "machineSerialNumber",
      });
    }
    if (userDetails.role === USER_ROLES.ADMIN) {
      filtersArr.push({ label: "Filter by OEM", value: "oem" });
    }
    return filtersArr;
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case "dealerName":
        return (
          <SiTextField
            placeholder="Dealer Name"
            name="dealerName"
            onChange={handleFilterValueChange}
          />
        );

      case "dateOfClaimSubmission":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>Start Date</p>
              <SiTextField
                placeholder="Start Date"
                name="startDate"
                type="date"
                onChange={handleFilterValueChange}
                sx={{ mt: 1 }}
              />
            </div>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>End Date</p>
              <SiTextField
                placeholder="End Date"
                name="endDate"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 1 }}
              />
            </div>
          </Box>
        );
      case "oem":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM"
            onInputChange={(newInputValue) => handleRegexSearch(newInputValue)}
          />
        );
      case "claimReferenceNumber":
        return (
          <SiTextField
            placeholder="Claim Reference Number"
            name="claimReferenceNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "engineSerialNumber":
        return (
          <SiTextField
            placeholder="Engine Serial Number"
            name="engineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "machineSerialNumber":
        return (
          <SiTextField
            placeholder="Machine Serial Number"
            name="machineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "simpsonPartNumber":
        return (
          <SiTextField
            placeholder="Simpson Part Number"
            name="simpsonPartNumber"
            onChange={handleFilterValueChange}
          />
        );
      default:
        return null;
    }
  };
  const getOemList = (inputValue) => {
    const params = inputValue ? { name: inputValue } : {};
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ADMIN_OEMS}`,
      null,
      params
    )
      .then((response) => {
        if (Array.isArray(response) && response) {
          let oems = response.map((r) => {
            return {
              ...r,
              label: `${r.code}-${r.name}`,
              value: r.id,
            };
          });

          setOemList(oems);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  useEffect(() => {
    if (filterType === "oem" && userDetails.role === USER_ROLES.ADMIN) {
      getOemList();
    }
  }, [filterType]);
  console.log(filterType);
  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes()}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default ClaimsFilters;
